"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapImages = void 0;
// Types
const types_1 = require("./types");
const mapImages = (images) => {
    return images.reduce((acc, img) => {
        const key = img.channel === 'WEB' ? types_1.DeviceBreakpointsType.WEB_DESKTOP : img.channel;
        acc[key] = img.imageUrl;
        return acc;
    }, {});
};
exports.mapImages = mapImages;
//# sourceMappingURL=mapImages.utility.js.map